import {useIntl} from 'react-intl'
import {useGetUserDetail} from '../../context/useQuery'
import {useUpdateUser} from '../../context/useMutation'
import {useStore} from '../../hook'
import {useState} from 'react'
import {Formik} from 'formik'
import {Form} from 'react-bootstrap'
import {InlineTable} from 'src/feature/bite/component'
import * as Yup from 'yup'

const StoreUserDetail = ({loading}: {loading: boolean}) => {
  const intl = useIntl()
  const {detail, userDetail} = useStore()
  const [editable, setEditable] = useState(false)

  const {isLoading, refetch} = useGetUserDetail(detail?.id || '')
  const {mutateAsync} = useUpdateUser()

  const Data = userDetail?.user || null

  const column = [
    [
      {
        key: 'FirstName',
        dataIndex: 'firstName',
        title: intl.formatMessage({id: 'STORE.DETAIL.CONTACT.NAME'}),
        edit: 'input',
      },
      {
        key: 'LastName',
        dataIndex: 'lastName',
        title: intl.formatMessage({id: 'STORE.DETAIL.CONTACT.SURNAME'}),
        edit: 'input',
      },
    ],
    [
      {
        key: 'Email',
        dataIndex: 'email',
        title: intl.formatMessage({id: 'STORE.DETAIL.CONTACT.EMAIL'}),
        // edit: 'input',
      },
      {
        key: 'Status',
        dataIndex: 'status',
        title: intl.formatMessage({id: 'STORE.DETAIL.CONTACT.STATUS'}),
        status: true,
        disabled: true,
        edit: 'select',
        valueSelect: true,
        selects: [
          {value: 1, text: 'Active'},
          {value: 2, text: 'Inactive'},
          // {value: 3, text: 'Passive'},
        ],
      },
    ],
  ]

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required('First Name is required')
      .max(25, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 25})),
    lastName: Yup.string()
      .required('Last Name is required')
      .max(25, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 25})),
    email: Yup.string()
      .email(intl.formatMessage({id: 'GLOBAL.VALIDATION.EMAIL'}))
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(100, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 100})),
    status: Yup.string(),
  })

  const handleSave = async (values: {
    firstName: string
    lastName: string
    email: string
    status: string | number
  }) => {
    let data = {
      ...Data,
      ...values,
    }

    if (values?.status === '') {
      data.status = Number(values?.status)
    }

    await mutateAsync({
      values: {
        ...Data,
        ...values,
      },
    })
    refetch()
    setEditable(false)
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bold m-0'>{intl.formatMessage({id: 'STORE.DETAIL.USER_DETAIL'})}</h3>
          </div>
        </div>

        {Data && (
          <Formik
            initialValues={{
              firstName: Data?.firstName || '',
              lastName: Data?.lastName || '',
              email: Data?.email || '',
              status: Data?.status || '0',
            }}
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={(values) => {
              handleSave(values)
            }}
          >
            {({values, errors, touched, handleSubmit}) => (
              <Form
                onSubmit={(e) => {
                  e.preventDefault()
                  handleSubmit(e)
                }}
              >
                <div className='card-body p-9'>
                  <InlineTable
                    loading={loading}
                    dataSource={Data}
                    columns={column}
                    editable={editable}
                    values={values}
                  />
                </div>
                {/* {Data.roleName === 'Owner' ? (
                  <></>
                ) : ( */}
                <div className='card-footer d-flex w-100 justify-content-end'>
                  {editable ? (
                    <div>
                      <button
                        className='btn btn-primary'
                        style={{marginRight: 10}}
                        // disabled={Data.roleId}
                        onClick={() => setEditable(false)}
                      >
                        <i className='bi bi-x me-2'></i>
                        {intl.formatMessage({id: 'GLOBAL.BUTTON.CANCEL'})}
                      </button>
                      <button className='btn btn-primary' disabled={isLoading}>
                        <i className='bi bi-save2 me-2'></i>
                        {isLoading
                          ? intl.formatMessage({id: 'GLOBAL.BUTTON.SAVING'})
                          : intl.formatMessage({id: 'GLOBAL.BUTTON.SAVE'})}
                      </button>
                    </div>
                  ) : (
                    <button className='btn btn-primary' onClick={() => setEditable(true)}>
                      <i className='bi bi-pencil me-2'></i>
                      {intl.formatMessage({id: 'GLOBAL.BUTTON.EDIT'})}
                    </button>
                  )}
                </div>
                {/* )} */}
              </Form>
            )}
          </Formik>
        )}
      </div>
    </>
  )
}

export default StoreUserDetail
